import cn from 'classnames';
import ContentLoader from 'react-content-loader';
import { contentLoaderConfig } from 'shared/constants/common';
import { useIsLoggedIn } from 'shared/hooks/useIsLoggedIn';
import useResolvedColorScheme from 'shared/hooks/useResolvedColorScheme';
import { LoaderBannerTypes } from '../Banner.types';
export const LoaderSquare = ({ visible, className }: LoaderBannerTypes) => {
	const isLoggedIn = useIsLoggedIn();
	const { resolvedColorScheme } = useResolvedColorScheme();
	const contentLoaderColor = resolvedColorScheme === 'dark' ? contentLoaderConfig.backgroundColor.dark : contentLoaderConfig.backgroundColor.light;

	return visible && !isLoggedIn ? (
		<div className={cn('w-full aspect-[524/233] md:aspect-[10/3]', className)}>
			<ContentLoader width="100%" height={'100%'} backgroundColor={contentLoaderColor} foregroundColor={contentLoaderColor}>
				<rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
			</ContentLoader>
		</div>
	) : null;
};
